import { axiosGet } from "../../Helpers";

export const loadDegrees = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("degree/listDegree");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
